// import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { cmsService } from '../services/homii-services';
import HeroSection from '../components/corporate-pages-content/hero-section.component';
import DifferenceSection from '../components/corporate-pages-content/difference-section.component';
import PartnerSection from '../components/corporate-pages-content/partners-section.component';
import ImageSection from '../components/corporate-pages-content/image-section.component';
import InvestorsSection from '../components/corporate-pages-content/investors-section.component';
import CommercialRentalSection from '../components/corporate-pages-content/commerical-rental-section.component';
import VideoSection from '../components/live-page-components/video-section.component';
import MobileAppSection from '../components/home-page-components/mobile-app-section.component';
import PartnersForm from '../components/get-in-touch-components/partners-form.component';
import CityCarousel from '../components/city-carousel/city-carousel.component';
import CityCarouselMobile from '../components/city-carousel/city-carousel-mobile.component';
import { cityDomain } from '../domain';
import { Layout, Footer, MetaData } from '../components/shared';
import useResponsive from '../../utils/responsive';

const Partners = (props) => {

    const { data, baseUrlApp, cities } = props;
    const { isMobile } = useResponsive();
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroParagraph = _.get(data, 'acf.hero_paragraph');
    const heroImgSrc = _.get(data, 'acf.hero_main_image');
    const heroImgAlt = _.get(data, 'acf.hero_main_image_alt');
    const differenceTitle = _.get(data, 'acf.difference_section_title');
    const differenceParagraph = _.get(data, 'acf.difference_section_paragraph');
    const differenceImgSrc = _.get(data, 'acf.difference_section_image.url');
    const differenceImgAlt = _.get(data, 'acf.difference_section_image_alt');
    const partnerTitle = _.get(data, 'acf.partner_section_title');
    const partnerParagraph = _.get(data, 'acf.partner_section_paragraph');
    const partnerImgSrc = _.get(data, 'acf.partner_section_image.url');
    const partnerImgAlt = _.get(data, 'acf.partner_section_image_alt');
    const partnerIcons = _.get(data, 'acf.partner_section_icons');
    const imageSrc = _.get(data, 'acf.image_section_image.url');
    const imageAlt = _.get(data, 'acf.image_section_image_alt');
    const imageQuoteTitle = _.get(data, 'acf.image_section_quote_title');
    const imageQuoteParagraph = _.get(data, 'acf.image_section_quote_paragraph');
    const imageQuoteAuthorDetails = _.get(data, 'acf.image_section_quote_author_details');
    const investorTitle = _.get(data, 'acf.investing_section_title');
    const investorParagraph = _.get(data, 'acf.investing_section_paragraph');
    const investorSubheading = _.get(data, 'acf.investing_section_sub_heading');
    const investorImgSrc = _.get(data, 'acf.investing_section_image.url');
    const investorImgAlt = _.get(data, 'acf.investing_section_image_alt');
    const investorParagraphs = _.get(data, 'acf.investing_section_paragraph_content');
    const videoUrl = _.get(data, 'acf.video_url');
    const commercialRentalTitle = _.get(data, 'acf.commercial_rental_section_title');
    const commercialRentalParagraph = _.get(data, 'acf.commercial_rental_section_paragraph');
    const commercialRentalImgSrc = _.get(data, 'acf.commercial_rental_section_image.url');
    const commercialRentalAlt = _.get(data, 'acf.commercial_rental_section_image_alt');
    const commercialRentalParagraphTitle = _.get(
        data,
        'acf.commercial_rental_section_paragraph_title',
    );
    const commercialRentalParagraphText = _.get(
        data,
        'acf.commercial_rental_section_paragraph_text',
    );
    const commercialRentalIcons = _.get(data, 'acf.commercial_rental_section_icons');

    const mobileAppTitle = _.get(data, 'acf.mobile_title');
    const mobileAppParagraph = _.get(data, 'acf.mobile_paragraph');
    const mobileAppIcon = _.get(data, 'acf.mobile_icon.url');
    const mobileAppIconText = _.get(data, 'acf.mobile_icon_text');
    const mobilePrimaryImgSrc = _.get(data, 'acf.mobile_primary_image.url');
    const mobilePrimaryImgAlt = _.get(data, 'acf.mobile_primary_image_alt');
    const mobileAppSecondaryImgSrc = _.get(data, 'acf.mobile_secondary_image.url');
    const mobileAppSecondaryImgAlt = _.get(data, 'acf.mobile_secondary_image_alt');
    const citiesTitle = _.get(data, 'acf.city_title');
    const citiesParagraph = _.get(data, 'acf.city_paragraph');

    return (
        <Layout>

            <MetaData title={seoTitle} desc={seoMetaDesc} canonical={`${baseUrlApp}/partners`} />

            <div className='corporate-container'>
                <HeroSection
                    negativeMargin
                    title={heroTitle}
                    paragraph={heroParagraph}
                    imgSrc={heroImgSrc}
                    imgAlt={heroImgAlt}
                    id="partners_header"
                    hasButton
                />
            </div>

            <DifferenceSection
                title={differenceTitle}
                paragraph={differenceParagraph}
                imgSrc={differenceImgSrc}
                imgAlt={differenceImgAlt}
            />

            <PartnerSection
                title={partnerTitle}
                paragraph={partnerParagraph}
                imgSrc={partnerImgSrc}
                imgAlt={partnerImgAlt}
                icons={partnerIcons}
            />

            <ImageSection
                imgSrc={imageSrc}
                imgAlt={imageAlt}
                title={imageQuoteTitle}
                paragraph={imageQuoteParagraph}
                authorDetails={imageQuoteAuthorDetails}
            />

            <InvestorsSection
                title={investorTitle}
                paragraph={investorParagraph}
                subHeading={investorSubheading}
                imgSrc={investorImgSrc}
                imgAlt={investorImgAlt}
                paragraphContent={investorParagraphs}
            />

            <VideoSection
                videoUrl={videoUrl}
                isPartners
                alignRight
            />

            <CommercialRentalSection
                title={commercialRentalTitle}
                paragraph={commercialRentalParagraph}
                imgSrc={commercialRentalImgSrc}
                imgAlt={commercialRentalAlt}
                icons={commercialRentalIcons}
                paragraphTitle={commercialRentalParagraphTitle}
                paragraphText={commercialRentalParagraphText}
            />

            {isMobile ? 
                <div className='carousel-container-mobile'>
                    <CityCarouselMobile title={citiesTitle} paragraph={citiesParagraph} type="FindaSpace" cities={cities} />
                </div>
                : 
                <div className='container-root container-root-maxWidthLg blog-carousel-container carousel-container-settings'>
                    <CityCarousel title={citiesTitle} paragraph={citiesParagraph} type="FindaSpace" cities={cities} />
                </div>
            }

            <div className='container-root container-root-maxWidthLg'>
                <PartnersForm />
            </div>

            <div className='corporate-container'>
                <MobileAppSection
                    isDark                    
                    title={mobileAppTitle}
                    paragraph={mobileAppParagraph}
                    icon={mobileAppIcon}
                    iconText={mobileAppIconText}
                    primaryImgSrc={mobilePrimaryImgSrc}
                    primaryImgAlt={mobilePrimaryImgAlt}
                    secondaryImgSrc={mobileAppSecondaryImgSrc}
                    secondaryImgAlt={mobileAppSecondaryImgAlt}
                />
            </div>
            
            <Footer />

        </Layout>
    );
};

export default Partners;

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('partners'); 
    const cities = await cityDomain.fetchAllCitiesData();   
    return {
        props: {
            data: resp,
            cities
        }
    };
};

Partners.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
};
